// extracted by mini-css-extract-plugin
export default {"imageWrapper":"vO-z","hovered":"wO-z","hoverImage":"xO-z","mainImage":"yO-z","imageNoBackground":"zO-z","fullSizeImage":"AO-z"};